<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>적하보험</li>
        <li>보험료 견적</li>
      </ul>
    </div>
    <div class="contents">
      <div class="conWrap">
        <h3 class="conTit">보험료 견적</h3>
        <div class="tabStyle1">
          <table>
            <caption>
              조회결과
            </caption>
            <colgroup>
              <col width="200" />
              <col width="400" />
              <col width="200" />
              <col width="400" />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  <label for="pol">출항지</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>먼저 도착할 국가를 선택한 후 도시를 선택함</dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpTxt">
                    <input
                      type="text"
                      id="pol"
                      title="출항지"
                      @mouseover="hover = true"
                      @mouseleave="hover = false"
                      @click="openPopup('popStplCdCityCode')"
                      v-model="state.stplCd"
                    />
                  </div>
                </td>
                <th scope="row">
                  <label for="polModi">출항지 정정</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        좌측의 출발항란의 도시명과 실제 출력할 국가 및 도시명
                        입력
                      </dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      id="polModi"
                      title="출항지 정정"
                      v-model="state.stplNm"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="pod">도착지</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>먼저 도착할 국가를 선택한 후 도시를 선택함</dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpTxt">
                    <input
                      type="text"
                      id="pod"
                      title="도착지"
                      @click="openPopup('popArarCdCityCode')"
                      v-model="state.ararCd"
                    />
                  </div>
                </td>
                <th scope="row">
                  <label for="podModi">도착지 정정</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        좌측의 도착항란의 도시명과 실재 출력할 국가 및 도시명
                        입력
                      </dd>
                    </dl>
                  </div>
                </th>
                <td>
                  <div class="inpTxt typeReq">
                    <input
                      type="text"
                      id="podModi"
                      title="도착지 정정"
                      v-model="state.ararNm"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  운송수단명
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        선박과 비행기 중 하나를 반드시 선택하시고 선박명을 알고
                        있는 경우 우측 빈칸에 입력
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="typeSplit2">
                    <div class="inpSlt">
                      <button
                        type="button"
                        class="sltBtn"
                        title="운송수단명 선택"
                      >
                        <span></span>
                      </button>
                      <ul>
                        <li
                          v-for="(item, index) in state.trnMnNmList"
                          :key="index"
                        >
                          <button
                            type="button"
                            class="sltOpt"
                            @click="onSelectEvent('trnMnNm', item)"
                          >
                            <span>{{ item.name }}</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                    <div class="inpTxt typeReq">
                      <input
                        type="text"
                        title="운송수단명"
                        v-model="state.trnMnNm"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="pdtCode">품목코드</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        보험을 가입하는 물품을 선택하십시오. 보험가입물품이 여러
                        종류일 경우에는<br />
                        INVOICE AMOUNT 가 가장 큰 품목을 대표품목으로 선택하세요
                        (HS CODE 참조)<br />
                        주의: 보험요율 산출과 클레임 처리시 중요한 사항임으로
                        주의하여 선택하세요
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpTxt">
                    <input
                      type="text"
                      placeholder="선택해 주세요"
                      id="pdtCode"
                      readonly
                      title="품목코드"
                      @click="openPopup('popPdtCode')"
                      v-model="state.itmCd"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="hsCode">H-S CODE</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        HS CODE 대분류 4 자리를 입력하시면 가입 하고자 하는
                        품목이 선택됩니다.<br />
                        해당 자료가 없는 경우 당사 해상항공업무팀<br />
                        (02-6464-3216,3218,3219,3222,3226) 으로 문의하시기
                        바랍니다.
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpTxt">
                    <input
                      type="text"
                      placeholder="클릭"
                      id="hsCode"
                      title="H-S CODE"
                      @click="openPopup('popHsCode')"
                      v-model="state.hsCd"
                    />
                  </div>
                  <p class="inpInfo fcRed">
                    어획물, 화공품, 유류, 시베리아횡단철도 및 중국횡단철도화물은
                    당사로 문의 바랍니다.
                  </p>
                </td>
              </tr>
              <tr>
                <th scope="row">INVOICE금액</th>
                <td colspan="3">
                  <div class="typeSplit3">
                    <dl>
                      <dt>환종</dt>
                      <dd>
                        <div class="inpSlt">
                          <button
                            type="button"
                            class="sltBtn"
                            title="환종 선택"
                          >
                            <span></span>
                          </button>
                          <ul>
                            <li
                              v-for="(item, index) in state.curList"
                              :key="index"
                            >
                              <button
                                type="button"
                                class="sltOpt"
                                @click="onSelectEvent('cur', item)"
                              >
                                <span>{{ item.code }}/{{ item.name }}</span>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </dd>
                    </dl>
                    <dl>
                      <dt>
                        <label for="profit">희망이익률(%)</label>
                        <div class="toolTip">
                          <button type="button"><span>용어설명</span></button>
                          <dl>
                            <dt>용어설명</dt>
                            <dd>
                              화물이 목적지에 도착함으로써 화주가 얻을수 있는<br />
                              금전적 이익으로 110%가 일반적임.(최대 150%까지
                              입력가능)
                            </dd>
                          </dl>
                        </div>
                      </dt>
                      <dd>
                        <div class="inpTxt typeReq">
                          <input
                            type="text"
                            id="profit"
                            title="희망이익률"
                            class="tar"
                            v-model="state.hop"
                          />
                        </div>
                      </dd>
                    </dl>
                  </div>
                  <div class="typeSplit3">
                    <dl>
                      <dt>
                        <label for="pay">금액</label>
                        <div class="toolTip">
                          <button type="button"><span>용어설명</span></button>
                          <dl>
                            <dt>용어설명</dt>
                            <dd>INVOICE가액을 입력</dd>
                          </dl>
                        </div>
                      </dt>
                      <dd>
                        <div class="inpTxt typeReq">
                          <input
                            type="text"
                            placeholder="예시) 10000.35"
                            id="pay"
                            maxlength="13"
                            title="금액"
                            v-model="state.ttFormatInvcVamtAmt"
                            @input="formatAmt"
                          />
                        </div>
                      </dd>
                    </dl>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  포장형태
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>포장형태포장형태포장형태</dd>
                      type="text"
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpSlt">
                    <button type="button" class="sltBtn" title="포장형태 선택">
                      <span>{{
                        state.packShNm != "" ? state.packShNm : "선박해 주세요"
                      }}</span>
                    </button>
                    <ul>
                      <li
                        v-for="(item, index) in state.packShList"
                        :key="index"
                      >
                        <button
                          type="button"
                          class="sltOpt"
                          @click="onSelectEvent('packShCd', item)"
                        >
                          <span>{{ item.name }}</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  보험조건
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        ALL RISK조건만 청약입력이 가능하며 기타 조건은
                        담당자가에게 FAX로 의뢰하시고 출력만 가능합니다
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpSlt">
                    <button type="button" class="sltBtn" title="보험조건 선택">
                      <span>보험조건 선택</span>
                    </button>
                    <ul>
                      <li
                        v-for="(item, index) in state.insCndList"
                        :key="index"
                      >
                        <button
                          type="button"
                          class="sltOpt"
                          @click="onSelectEvent('insCnd', item)"
                        >
                          <span
                            >{{ item.addtlCovCd }} / {{ item.addtlCovNm }}</span
                          >
                        </button>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  부가조건
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>기본조건외 추가로 담보를 원할 경우 사용</dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div
                    class="typeSplit4"
                    v-for="(item, index) in state.acTermsList"
                    :key="index"
                  >
                    <div class="inpTxt">
                      <input
                        type="text"
                        title="부가조건1_1"
                        @click="openPopup('popAddition')"
                        v-model="item.addtlCovNm"
                      />
                    </div>
                    <div class="inpTxt">
                      <input
                        type="text"
                        title="부가조건1_2"
                        v-model="item.text"
                      />
                    </div>
                    <div class="inpTxt">
                      <input
                        type="text"
                        title="부가조건1_3"
                        v-model="item.addTrmUnt1"
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  <label for="etc">기타조건</label>
                  <div class="toolTip">
                    <button type="button"><span>용어설명</span></button>
                    <dl>
                      <dt>용어설명</dt>
                      <dd>
                        L/C 서류상 보험관련 문구를 입력하고자 할 경우 사용.(최대
                        60 bytes입력가능)
                      </dd>
                    </dl>
                  </div>
                </th>
                <td colspan="3">
                  <div class="inpTextarea typeReq">
                    <textarea
                      placeholder="내용을 입력하세요."
                      id="etc"
                      v-model="state.etcCnd"
                    ></textarea>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <p class="fcRed">
            ※상기 보험료견적은 가입시 기타조건 및 인수기준에 따라 변동될 수
            있습니다.
          </p>
        </div>
        <div class="btnWrap">
          <a class="btnType sizeR colorBL" @click="clearAll()"
            ><span>다시작성</span></a
          >
          <a class="btnType sizeR colorB" @click="save()"
            ><span>보험료 산출</span></a
          >
        </div>
      </div>
    </div>
  </div>
  <PopCityCode
    ref="popStplCdCityCode"
    @update:data="
      (eventData) => handleDataFromPopup('popStplCdCityCode', eventData)
    "
  ></PopCityCode>

  <PopCityCode
    ref="popArarCdCityCode"
    @update:data="
      (eventData) => handleDataFromPopup('popArarCdCityCode', eventData)
    "
  ></PopCityCode>

  <PopHsCode
    ref="popHsCode"
    @update:data="(eventData) => handleDataFromPopup('popHsCode', eventData)"
  ></PopHsCode>

  <PopAddition
    ref="popAddition"
    @update:data="(eventData) => handleDataFromPopup('popAddition', eventData)"
  ></PopAddition>
  <PopMemoW
    ref="popMemoW"
    @update:data="(eventData) => handleDataFromPopup('popMemoW', eventData)"
  ></PopMemoW>
  <PopPwChange
    ref="popPwChange"
    @update:data="(eventData) => handleDataFromPopup('popPwChange', eventData)"
  ></PopPwChange>

  <PopPdtCode
    ref="popPdtCode"
    @update:data="(eventData) => handleDataFromPopup('popPdtCode', eventData)"
    @close="handlePopupClose"
  ></PopPdtCode>
</template>

<script setup>
// @ is an alias to /src

import {
  ref,
  reactive,
  inject,
  onMounted,
  onBeforeUpdate,
  getCurrentInstance,
} from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import util from "@/common/util";
import { format } from "date-fns";
import { Decimal } from "decimal.js";

import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";

import PopAddition from "@/components/common/layerPop/PopAddition.vue";
import PopMemoW from "@/components/common/layerPop/PopMemoW.vue";
import PopPdtCode from "@/components/common/layerPop/PopPdtCode.vue";
import PopPwChange from "@/components/common/layerPop/PopPwChange.vue";

import PopCityCode from "@/components/common/layerPop/PopCityCode.vue";
import PopHsCode from "@/components/common/layerPop/PopHsCode.vue";

import * as codeList from "@/common/code";
const route = useRoute();

const axios = inject("axios");

const swalAlert = inject("swalAlert");
const swalConfirm = inject("swalConfirm");

const popStplCdCityCode = ref(null);
const popArarCdCityCode = ref(null);
const popPdtCode = ref(null);
const popHsCode = ref(null);
const popAddition = ref(null);

const state = reactive({
  temCtgCdList: [], //팀분류 코드
  refNo1List: [], //참조번호1
  refNo2List: [], //참조번호2
  trnMnNmList: [], //운송수단명
  plrBnkList: [], //질권은행명
  ortxtCpnoList: [], //원본부수
  insCndList: [], //보험조건
  curList: [], //환종
  packShList: [], //포장형태
  n_ctoren: "", //계약자 영문명
  n_ctorkr: "", //계약자 한글명
  n_ctoren1: "", //계약자 영문명
  n_ctorkr1: "", //계약자 한글명
  n_ctoren2: "", //계약자 영문명
  n_ctorkr2: "", //계약자 한글명
  refnNoCd1: "", //참조번호
  refnNoCd2: "", //참조번호2
  tkffDd: "", //출항일
  stplCd: "", //출항항
  stplNm: "", //출항항 정정
  ararCd: "", //도착항
  ararNm: "", //도착항 정정
  bgnDt: "", //개시일자
  itmCd: "",
  itmCdNm: "",
  packShCd: "", //포장형태코드
  packShNm: "", //포장형태코드명
  cargTrnDtlsDivCd: "05",
  cmcMnUstmnYn: "2",
  acpShDivCd: "",
  currentDate: format(new Date(), "yyyyMMdd"),
  acTermsList: [{}],
  bzacId: "",
  bzacNm: "",
  korNatlNm: "",

  bankNm: "", //질권은행명
  prctrNo: "",
  ctrId: "",
  strAcpShDivCd: "",
  hisSeq: "",
  hop: "",
  // odshRt: "",
  ttInvcVamtAmt: 0,
  ttFormatInvcVamtAmt: "",
  trnMnNmCd: "",
  trnMnNmCdNm: "",
  trnMnNm: "",
  hsCd: "",
  vygZoneCd: "",
  obj: "  ",
  etcCnd: "",
  addtlCovCd: "",
  addtlCovNm: "",
  curNm: "",
  ortxtCpnoNm: "",
});

//팝업 확인콜백
const handleDataFromPopup = async (popupId, eventData) => {
  if (popupId == "popStplCdCityCode") {
    state.stplCd = eventData.d.CITY_NTN_CD.trim();
    state.stplNm =
      eventData.d.CITY_NTN_NM.trim() + "/" + eventData.d.NTN_NM.trim();
    state.vygZoneCd = eventData.d.VOYAGE_AREA_CD;
  } else if (popupId == "popArarCdCityCode") {
    state.ararCd = eventData.d.CITY_NTN_CD.trim();
    state.ararNm =
      eventData.d.CITY_NTN_NM.trim() + "/" + eventData.d.NTN_NM.trim();

    var param = {};
    param.cityNatlCd = state.ararCd;

    if ("KO" == state.ararCd.substring(0, 2)) {
      param.domeOvrseaDivCd = "1";
    } else {
      param.domeOvrseaDivCd = "2";
    }

    //손사 법인조회
    let result = await axios.transaction("FNGCLMAO0004", param);

    state.bzacId = result.body.cladjCrpInqDtlBcVo[0].bzacId;
    state.bzacNm = result.body.cladjCrpInqDtlBcVo[0].bzacNm;
  } else if (popupId == "popPdtCode") {
    if ("216010100" == eventData.itmCd) {
      swalConfirm(
        "본사는 중고기계및 기기를 적하보험으로써 인수하지 않습니다.\n이 사항을 숙지하였고 해당 품목이 중고기계및 기기가 아님을\n확인하셨습니까?"
      ).then((result) => {
        //예
        if (result.isConfirmed) {
          state.itmCd = eventData.itmCd;
        }
      });
    } else if ("303010100" == eventData.itmCd) {
      swalConfirm(
        "가구류, 자개류(조가비포함), 표구, 회화 및 Dry Flower등 깨지기 쉬운 화물에 대해 A/R, A/R(Air). ICC(A), ICC(Air)로 가입하는 경우에도 Breakage 위험을 별도로 가입하여야 하며(가입을 원하는 경우 부가조건에서 Breakage를 선택하십시오), Breakage 위험을 추가 담보하지 않는 경우 파손으로 기인한 여하한 손상은 담보하지 않음을 확인하셨습니까?"
      ).then((result) => {
        //예
        if (result.isConfirmed) {
          state.itmCd = eventData.itmCd;
        }
      });
    } else {
      state.itmCd = eventData.itmCd;
      state.itmCdNm = eventData.itmNm;
    }
  } else if (popupId == "popAddition") {
    state.acTermsList = eventData.filterObject;
  } else if (popupId == "popHsCode") {
    state.hsCd = eventData;
  }
};

const onSelectEvent = (selectId, data) => {
  if (selectId == "refNo1") {
    state.refNo1 = data.code;
  } else if (selectId == "refNo2") {
    state.refNo2 = data.code;
  } else if (selectId == "plrBnk") {
    state.plrBnk = data.code;
    state.bankNm = data.name;
  } else if (selectId == "ortxtCpno") {
    state.ortxtCpno = data.code;
  } else if (selectId == "trnMnNm") {
    state.trnMnNmCd = data.code;
  } else if (selectId == "cur") {
    state.cur = data.code;
  } else if (selectId == "packShCd") {
    state.packShCd = data.code;
    retrieveBasCov();
  } else if (selectId == "insCnd") {
    state.addtlCovCd = data.addtlCovCd;
    state.addtlCovNm = data.addtlCovNm;
  }
};

//팝업닫기
const handlePopupClose = () => {};

const openPopup = (name) => {
  if ("popStplCdCityCode" == name) {
    popStplCdCityCode.value.open();
  } else if ("popArarCdCityCode" == name) {
    popArarCdCityCode.value.open();
  } else if ("popPdtCode" == name) {
    popPdtCode.value.open();
  } else if ("popAddition" == name) {
    var pdCd = "21010";
    if ("KO" == state.ararCd.substring(0, 2)) {
      pdCd = "21000";
    }

    var object = {
      pdCd: pdCd,
      itmCd: state.itmCd,
      vygZone: "",
      basCndCd: state.addtlCovCd,
      dtlsDivCd: state.cargTrnDtlsDivCd,
      acpShCd: state.acpShDivCd,
      ftrnOdDivCd: "01",
      addCov0: "",
      addCov1: "",
      addCov2: "",
      addCov3: "",
      addTrm0: "",
      addTrm1: "",
      addTrm2: "",
      addTrm3: "",
      packCd: state.packShCd,
    };
    popAddition.value.open(object);
  } else if ("popHsCode" == name) {
    popHsCode.value.open();
  }
};

//다시 작성
const clearAll = () => {
  swalConfirm("정말로 다시 작성하시겠습니까?").then((result) => {
    //예
    if (result.isConfirmed) {
      console.log("다시 작성");
      state.temCtgCdList = []; //팀분류 코드
      state.refNo1List = []; //참조번호1
      state.refNo2List = []; //참조번호2
      state.trnMnNmList = []; //운송수단명
      state.plrBnkList = []; //질권은행명
      state.ortxtCpnoList = []; //원본부수
      state.insCndList = []; //보험조건
      state.curList = []; //환종
      state.packShList = []; //포장형태
      state.n_ctoren = ""; //계약자 영문명
      state.n_ctorkr = ""; //계약자 한글명
      state.n_ctoren1 = ""; //계약자 영문명
      state.n_ctorkr1 = ""; //계약자 한글명
      state.n_ctoren2 = ""; //계약자 영문명
      state.n_ctorkr2 = ""; //계약자 한글명
      state.refnNoCd1 = ""; //참조번호
      state.refnNoCd2 = ""; //참조번호2
      state.tkffDd = ""; //출항일
      state.stplCd = ""; //출항항
      state.stplNm = ""; //출항항 정정
      state.ararCd = ""; //도착항
      state.ararNm = ""; //도착항 정정
      state.bgnDt = ""; //개시일자
      state.itmCd = "";
      state.itmCdNm = "";
      state.packShCd = ""; //포장형태코드
      state.packShNm = ""; //포장형태코드명
      state.cargTrnDtlsDivCd = "05";
      state.cmcMnUstmnYn = "2";
      state.acpShDivCd = "";
      state.currentDate = format(new Date(), "yyyyMMdd");
      state.acTermsList = [{}];
      state.bzacId = "";
      state.bzacNm = "";
      state.korNatlNm = "";
      state.bankNm = ""; //질권은행명
      state.prctrNo = "";
      state.ctrId = "";
      state.strAcpShDivCd = "";
      state.hisSeq = "";
      state.hop = "";
      state.odshRt = "";
      state.ttInvcVamtAmt = 0;
      state.ttFormatInvcVamtAmt = "";
      state.trnMnNmCd = "";
      state.trnMnNmCdNm = "";
      state.trnMnNm = "";
      state.hsCd = "";
      state.vygZoneCd = "";
      state.obj = "  ";
      state.etcCnd = "";
      state.addtlCovCd = "";
      state.addtlCovNm = "";
      state.curNm = "";
      state.ortxtCpnoNm = "";
    }
  });
};

async function retrieveBasCov() {
  let param = {
    pdCd: "21010", //sessionUserInfo.userInfo.expt_prod_cd,
    itmCd: state.itmCd,
    packCd: state.packShCd,
    ftrnOdDivCd: state.trnMnNmCd,
  };
  let result = await axios.transaction("FNGCTNFO0067", param);
  console.log("result", result);
  state.insCndList = result.body.row;
}

const formatAmt = () => {
  const rawAmt = state.ttFormatInvcVamtAmt?.replace(/[^0-9]/g, "");
  const formatted = new Intl.NumberFormat().format(rawAmt);
  state.ttInvcVamtAmt = rawAmt;
  state.ttFormatInvcVamtAmt = formatted;
};

//보험료 계산시
const save = async () => {
  let voMap = {};
  let mrinSbcDsgCovInfBcVo = {}; // 해상가입설계담보정보
  let mrinSbcDsgCtrRelpeInfBcVo = {}; // 해상가입설계계약관계자정보
  let prctrDtlConBcVo = {}; // 가계약상세내용
  let gnrMrinFtrnOdVo = {}; // 운송용구
  let cargSbcDsgObjInfBcVo = {}; // 적하가입설계목적물정보

  let mrinSbcDsgCovInfBcVoList = [];
  let mrinSbcDsgCtrRelpeInfBcVoList = [];
  let prctrDtlConBcVoList = [];
  let gnrMrinFtrnOdVoList = [];
  let cargSbcDsgObjInfBcVoList = [];

  let strAcpShDivCd = "1";
  let strInetUsrId = ""; // 인터넷사용자ID
  let strBizpeNo = "";
  let strDsgDivCd = "1";
  let strCtrRelpeEngNm = ""; // 계약관계자영문명 (ctrRelpeEngNm)
  let strInsr_En = ""; // 계약관계자영문명 (피보험자1, 2, 3)
  let strCtrRelpeKorNm = ""; // 계약관계자한글명 (ctrRelpeKorNm)
  let strInsr_kor = ""; // 계약관계자한글명 (피보험자1, 2, 3)
  let strCusNo = ""; // 고객번호 (cusNo)
  let strPtyId = ""; // 당사자ID (ptyId)
  // if (strPtyId == "") {
  //   sessionUserInfo.slzCusInf.cusId;
  // }
  let strDtlCon = " "; // 상세내용 (dtlCon)
  // let strCorpNo = " ";

  let strHisSeq = state.hisSeq; //이력순번
  let strAgrmNagrmDiv = "1"; // 협정비협정구분
  let strAplExrtDt = state.currentDate; // 적용환율일자
  let strDsgDt = state.currentDate; // 설계일자
  let strSbcpDt = state.currentDate; // 청약일자
  let strArarCd = state.ararCd; // 도착지코드 (ararCd)
  let strArarNm = state.ararNm; // 도착지명 (ararNm)

  let strCargTrnDtlsDivCd = "05"; // 적하운송세부구분코드
  let strCmcMnUstmnYn = "2"; // 통신수단이용해지여부
  let strHopPftRt = state.hop; //희망이익율
  let strInsAmtPopa1 = "2NDVTzrgfO"; // 보험금지급지1 (insAmtPopa1)
  let strInsStdt = state.currentDate; // 보험시기 (insStdt)
  let strInsVamtCurCd = state.cur; // 보험가액환종코드 (insVamtCurCd)

  let strPdCd = "21010"; // 상품코드 (pdCd)
  let strUntPdCd = "2101A"; // 단위상품코드 (untPdCd)
  let strPolOrtxtNum = "2"; // 증권원본수 (polOrtxtNum)
  let strPyMd = "99"; // 납입방법
  let strRefnNoCd1 = state.refnNoCd1; // 참고번호코드1 (refnNoCd1)
  let strRefnNoCd2 = state.refnNoCd2; // 참고번호코드2 (refnNoCd2)
  let strRefnNoDivCd1 = ""; // 참고번호구분코드1 (refnNoDivCd1)
  let strRefnNoDivCd2 = ""; // 참고번호구분코드2 (refnNoDivCd2)
  let strSbcpChnDivCd = "03"; // 청약채널구분코드
  let strStplCd = state.stplCd; // 출발지코드 (stplCd)
  let strStplNm = state.stplNm; // 출발지명 (stplNm)
  let strTkffDd = ""; // 출항일 (tkffDd)
  let strTtInvcVamtAmt = state.ttInvcVamtAmt;
  if (strTtInvcVamtAmt == "") {
    strTtInvcVamtAmt = "0";
  }
  let strTtInvcVamtCur = state.cur; // 총송장가액환종 (ttInvcVamtCur)
  // let strUY = "2023"; // UY (uY)
  let strUY = util.formatDate(new Date(), "yyyy"); // UY (uY)
  let strVygZoneCd = "07"; // 항해구역코드 (vygZoneCd)
  let strAdjtCd = ""; // 정산코드 (adjtCd)

  let strFtrnOdNm = state.trnMnNm; // 운송용구명 (ftrnOdNm)
  let strTrnMnCd = state.trnMnNmCd; // 운송수단코드 (trnMnCd)
  let strHsCd = state.hsCd; // HS코드 (hsCd)
  let strInvcVamt = strTtInvcVamtAmt; // 송장가액 (invcVamt)
  let strInvcVamtCurCd = strTtInvcVamtCur; // 송장가액환종코드 (invcVamtCurCd)
  let strItmCd = state.itmCd; // 품목코드 (itmCd)
  let strItmCdNm = state.itmCdNm; // 품목코드명
  let strPackCd = state.packShCd; // 포장코드 ()

  strStplNm = strStplNm.replaceAll("&", "&amp;"); // 출발지명
  strArarNm = strArarNm.replaceAll("&", "&amp;"); // 도착지명

  // 수입보험 : 클레임 지급지 = MERITZ FIRE & MARINE INSURANCE CO.,LTD.
  if ("KO" == strArarCd.substring(0, 2)) {
    strInsAmtPopa1 = "2NDVTzrgfO";
    strPdCd = "21000";
    strUntPdCd = "2100A";
    strVygZoneCd = state.vygZoneCd;
  }

  //도착항, 출항항이 모두 KO가 아닌경우-> 청약제어(2014.05.20)
  if ("KO" != strArarCd.substring(0, 2) && "KO" != strStplCd.substring(0, 2)) {
    strCargTrnDtlsDivCd = "06"; //도착항, 출항항이 모두 KO가 아닌경우-> 적하운송세부구분코드 ='06'(삼국간) (14.08.05 김혜민)
  }

  voMap.acpShDivCd = strAcpShDivCd.trim();
  voMap.inetUsrId = strInetUsrId.trim();
  voMap.hisSeq = strHisSeq.trim();
  voMap.agrmNagrmDiv = strAgrmNagrmDiv.trim();
  voMap.aplExrtDt = strAplExrtDt.trim();
  voMap.ararCd = strArarCd.trim();
  voMap.ararNm = strArarNm.trim();
  voMap.basCovCd = state.addtlCovCd; //기본담보코드
  voMap.bizpeNo = strBizpeNo.trim();
  voMap.cargTrnDtlsDivCd = strCargTrnDtlsDivCd.trim();
  voMap.cmcMnUstmnYn = strCmcMnUstmnYn.trim();
  voMap.dsgDivCd = strDsgDivCd.trim();
  voMap.dsgDt = strDsgDt;
  voMap.hopPftRt = strHopPftRt.trim();
  voMap.insAmtPopa1 = strInsAmtPopa1.trim();
  voMap.insStdt = strInsStdt.trim();
  voMap.insVamtCurCd = strInsVamtCurCd;
  voMap.pdCd = strPdCd.trim();
  voMap.polOrtxtNum = strPolOrtxtNum;
  voMap.pyMd = strPyMd.trim();
  voMap.refnNoCd1 = strRefnNoCd1.trim();
  voMap.refnNoCd2 = strRefnNoCd2.trim();
  voMap.refnNoDivCd1 = strRefnNoDivCd1.trim();
  voMap.refnNoDivCd2 = strRefnNoDivCd2.trim();
  voMap.sbcpChnDivCd = strSbcpChnDivCd.trim();
  voMap.sbcpDt = strSbcpDt.trim();
  voMap.stplCd = strStplCd.trim();
  voMap.stplNm = strStplNm.trim();
  voMap.tkffDd = strTkffDd.trim();
  voMap.ttInvcVamtAmt = strTtInvcVamtAmt.trim();
  voMap.ttInvcVamtCur = strTtInvcVamtCur;

  if (voMap.stplCd == "") {
    swalAlert("출항항(국가) 을(를) 반드시 입력(선택) 하셔야합니다.");
    return;
  } else if (voMap.ararCd == "") {
    swalAlert("도착항(국가) 을(를) 반드시 입력(선택) 하셔야합니다.");
    return;
  }

  let ttSbcAmt = new Decimal(strTtInvcVamtAmt);
  console.log(ttSbcAmt instanceof Decimal);
  ttSbcAmt = Decimal.mul(ttSbcAmt, new Decimal(strHopPftRt));
  ttSbcAmt = ttSbcAmt.div(new Decimal("100"));
  ttSbcAmt = ttSbcAmt.toDecimalPlaces(2, Decimal.ROUND_FLOOR); //총가입금액 (송장금액*희망이익률)

  voMap.ttSbcAmt = ttSbcAmt.toString();
  voMap.untPdCd = strUntPdCd.trim();
  voMap.uY = strUY.trim();
  voMap.vygZoneCd = strVygZoneCd.trim();
  voMap.trnMnCd1 = strTrnMnCd.trim();
  voMap.dsgDiv = "1";
  voMap.polhdDiv = "1"; // 계약자구분은 일반계약자로 default set

  /*

 */

  // 해상가입설계담보정보 (mrinSbcDsgCovInfBcVo)
  mrinSbcDsgCovInfBcVo = {};

  mrinSbcDsgCovInfBcVo.covCd = state.addtlCovCd;
  mrinSbcDsgCovInfBcVo.covNm = state.addtlCovNm;
  mrinSbcDsgCovInfBcVo.covDivCd = "1";

  mrinSbcDsgCovInfBcVo.covtpAddTrmDiv = ""; //stArr[4];
  mrinSbcDsgCovInfBcVo.covtpAddTrmVal = ""; //stArr[5];
  mrinSbcDsgCovInfBcVoList.push(mrinSbcDsgCovInfBcVo);

  // 추가 해상가입설계담보정보 (mrinSbcDsgCovInfBcVo)
  _.each(state.acTermsList, function (value, idx) {
    mrinSbcDsgCovInfBcVo = {};
    mrinSbcDsgCovInfBcVo.covCd = value.addtlCovCd;
    mrinSbcDsgCovInfBcVo.covDivCd = "2";

    mrinSbcDsgCovInfBcVo.covNm = value.addtlCovNm;
    mrinSbcDsgCovInfBcVo.covtpAddTrmDiv = value.addTrm1;
    mrinSbcDsgCovInfBcVo.covtpAddTrmVal = value.text;
    mrinSbcDsgCovInfBcVo.addTrmUnt = value.addTrmUnt1;
    mrinSbcDsgCovInfBcVoList.push(mrinSbcDsgCovInfBcVo);
  });

  // 해상가입설계계약관계자정보 (mrinSbcDsgCtrRelpeInfBcVo)
  // 01 : 계약자
  mrinSbcDsgCtrRelpeInfBcVo = {};
  mrinSbcDsgCtrRelpeInfBcVo.adjtCd = strAdjtCd;
  mrinSbcDsgCtrRelpeInfBcVo.bizpeNo = strBizpeNo;
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCd = "01";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCdNm = "계약자";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtySeq = "0";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelCrpNo = state.crpNo;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeDivCd = "";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeEngNm = strCtrRelpeEngNm;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeKorNm = strCtrRelpeKorNm;
  mrinSbcDsgCtrRelpeInfBcVo.cusNo = strCusNo;
  let cusTpCd = "";
  if (state.crpNo == "1100000000000") {
    cusTpCd = "4";
  } else {
    let ind_corp_typ_cd = sessionUserInfo.userInfo.ind_corp_typ_cd;
    if (ind_corp_typ_cd == "C") {
      cusTpCd = "4";
    } else {
      cusTpCd = "2";
    }
  }
  mrinSbcDsgCtrRelpeInfBcVo.cusTpCd = cusTpCd; // 고객유형코드 (4 : 법인)
  mrinSbcDsgCtrRelpeInfBcVo.ptyDivCd = "03";
  mrinSbcDsgCtrRelpeInfBcVo.ptyId = strPtyId;
  mrinSbcDsgCtrRelpeInfBcVoList.push(mrinSbcDsgCtrRelpeInfBcVo);

  // 계약관계자영문명 (피보험자1, 2, 3)
  strInsr_En += state.n_ctoren;

  strInsr_En += state.n_ctoren1;

  strInsr_En += state.n_ctoren2;

  // 계약관계자한글명 (피보험자1, 2, 3)
  strInsr_kor += state.n_ctorkr;
  strInsr_kor += state.n_ctorkr1;
  strInsr_kor += state.n_ctorkr2;

  // 02 : 피보험자
  mrinSbcDsgCtrRelpeInfBcVo = {};
  mrinSbcDsgCtrRelpeInfBcVo.adjtCd = strAdjtCd;
  mrinSbcDsgCtrRelpeInfBcVo.bizpeNo = strBizpeNo;
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCd = "02";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtyRlCdNm = "피보험자";
  mrinSbcDsgCtrRelpeInfBcVo.ctrPtySeq = "0";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelCrpNo = state.crpNo;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeDivCd = "";
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeEngNm = strInsr_En;
  mrinSbcDsgCtrRelpeInfBcVo.ctrRelpeKorNm = strInsr_kor;
  mrinSbcDsgCtrRelpeInfBcVo.cusNo = strCusNo;
  mrinSbcDsgCtrRelpeInfBcVo.cusTpCd = cusTpCd; // 고객유형코드 (4 : 법인)
  mrinSbcDsgCtrRelpeInfBcVo.ptyDivCd = "03"; // 당사자구분코드 (03 : 영업고객)
  mrinSbcDsgCtrRelpeInfBcVo.ptyId = strPtyId;

  mrinSbcDsgCtrRelpeInfBcVoList.push(mrinSbcDsgCtrRelpeInfBcVo);

  strDtlCon = state.obj;
  if ("" != strDtlCon) {
    prctrDtlConBcVo.ctrConCd = "G002"; // 계약내용코드 (G002 : 목적물 설명)
    prctrDtlConBcVo.dtlCon = strDtlCon;

    prctrDtlConBcVoList.push(prctrDtlConBcVo);
  }

  if ("" != state.etcCnd) {
    prctrDtlConBcVo = {};
    prctrDtlConBcVo.ctrConCd = "G003"; // 계약내용코드 (G003 : 추가문구)
    prctrDtlConBcVo.dtlCon = state.etcCnd;
    prctrDtlConBcVoList.push(prctrDtlConBcVo);
  }

  prctrDtlConBcVo = {};
  prctrDtlConBcVo.ctrConCd = "G009"; // 계약내용코드 (G009 : 워런티)
  prctrDtlConBcVo.dtlCon = "SANCTION LIMITATION AND EXCLUSION CLAUSE";
  prctrDtlConBcVoList.push(prctrDtlConBcVo);

  gnrMrinFtrnOdVo.ftrnOdNm = strFtrnOdNm;
  gnrMrinFtrnOdVo.trnMnCd = strTrnMnCd;
  gnrMrinFtrnOdVoList.push(gnrMrinFtrnOdVo);

  cargSbcDsgObjInfBcVo.hsCd = strHsCd;
  cargSbcDsgObjInfBcVo.invcVamt = strInvcVamt;
  cargSbcDsgObjInfBcVo.invcVamtCurCd = strInvcVamtCurCd;
  cargSbcDsgObjInfBcVo.itmCd = strItmCd;
  cargSbcDsgObjInfBcVo.itmCdNm = strItmCdNm;
  cargSbcDsgObjInfBcVo.packCd = strPackCd;
  cargSbcDsgObjInfBcVoList.push(cargSbcDsgObjInfBcVo);

  voMap.mrinSbcDsgCovInfBcVo = mrinSbcDsgCovInfBcVoList;
  voMap.mrinSbcDsgCtrRelpeInfBcVo = mrinSbcDsgCtrRelpeInfBcVoList;
  voMap.prctrDtlConBcVo = prctrDtlConBcVoList;
  voMap.gnrMrinFtrnOdVo = gnrMrinFtrnOdVoList;
  voMap.cargSbcDsgObjInfBcVo = cargSbcDsgObjInfBcVoList;

  var result = await axios.transaction("FNGCTNFO0191", voMap);

  if (result.msg.standCd == "FNGPD100001") {
    let efct_pr_format = "";
    efct_pr_format = result.body.ttAplCr
      ? parseFloat(result.body.ttAplCr) * 100
      : 0;
    efct_pr_format = efct_pr_format.toFixed(5);

    var resultMessage = "보험료 산출 내용을 확인하시기 바랍니다.</br>";
    resultMessage += "입력이 정상 처리 되었습니다.</br>";
    resultMessage += "희망이익률은" + result.body.hopPftRt + "% </br>";

    resultMessage += "최종요율은" + efct_pr_format + "</br>";
    resultMessage += "환율은" + result.body.usdExrt + "</br>";
    resultMessage += "원하보험료는" + result.body.ttKwAplPrem + "입니다 </br>";
    swalAlert(resultMessage);
  } else {
    swalAlert("보험료 산출 오류입니다..");
    return false;
  }
};

init();

async function init() {
  //세션정보 조회
  await load();
  console.log("sessionUserInfo", sessionUserInfo);
  //팀 분류코드 조회
  const useTeamCodeStore = codeList.useTeamCodeStore();
  var result = await useTeamCodeStore.getTeamCodeList();
  state.temCtgCdList = result.body.enteAdjtMngInfBcVo;

  state.refNo1List = codeList.getRefNo1List;
  state.refNo2List = codeList.getRefNo1List;
  state.plrBnkList = codeList.getBankCodeList;
  state.ortxtCpnoList = codeList.getOrigCntCodeList;
  state.trnMnNmList = codeList.getTrsMethCodeList;
  state.curList = codeList.getCurCodeList;

  state.packShList = codeList.getPackageTypeList;

  state.n_ctoren = ""; //sessionUserInfo.userInfo.n_ctoren;
  state.n_ctorkr = ""; //sessionUserInfo.userInfo.n_ctorkr;
  if (sessionUserInfo == null) {
    state.crpNo = "1100000000000";
  } else {
    state.crpNo = sessionUserInfo.userInfo.corp_no; //법인번호
  }
  if (!_.isEmpty(route.query.prctrNo)) {
    let param = {
      prctrNo: route.query.prctrNo,
    };

    let result = await axios.transaction("FNGCTNFO0074", param);
    console.log("result.body", result.body);
    let prctrDtlConBcVo = result.body.prctrDtlConBcVo;
    let mrinSbcDsgCovInfBcVo = result.body.mrinSbcDsgCovInfBcVo;
    let cargSbcDsgObjInfBcVo = result.body.cargSbcDsgObjInfBcVo;
    let gnrMrinFtrnOdVo = result.body.gnrMrinFtrnOdVo;

    let mrinSbcDsgCtrRelpeInfBcVo = result.body.mrinSbcDsgCtrRelpeInfBcVo;

    _.each(prctrDtlConBcVo, function (value, idx) {
      let ctrConCd = value.ctrConCd;

      if (ctrConCd == "G002") {
        state.obj = value.dtlCon; //목적물
      } else if (ctrConCd == "G003") {
        state.etcCnd = value.dtlCon; //기타목적
      }
    });

    state.acTermsList = [];
    _.each(mrinSbcDsgCovInfBcVo, function (value, idx) {
      let covDivCd = value.covDivCd;
      //부가담보
      if (covDivCd == "2") {
        let acTerms = {};
        acTerms.addtlCovCd = value.covCd;

        acTerms.addtlCovNm = value.covNm;
        acTerms.addTrm1 = value.covtpAddTrmDiv;
        acTerms.text = value.covtpAddTrmVal;
        acTerms.addTrmUnt1 = value.addTrmUnt;
        state.acTermsList.push(acTerms);
      }
    });

    //계약자 , 피보험자 , 질권자 셋팅
    _.each(mrinSbcDsgCtrRelpeInfBcVo, function (value, idx) {
      let ctrPtyRlCd = value.ctrPtyRlCd;

      //질권자 셋팅
      if (ctrPtyRlCd == "11") {
        state.bankNm = value.ctrRelpeKorNm;
        state.plrBnk = value.ptyId;
      }
    });

    //출항일 셋팅
    state.tkffDd = result.body.tkffDd;

    //출발지 셋팅
    state.stplCd = result.body.stplCd;
    state.stplNm = result.body.stplNm;

    //도착지 셋팅
    state.ararCd = result.body.ararCd;
    state.ararNm = result.body.ararNm;

    //원본부수 셋팅
    // let polOrtxtNum = "2";
    // state.ortxtCpno = polOrtxtNum;

    _.each(state.ortxtCpnoList, function (value, idx) {
      if (state.ortxtCpno == value.code) {
        state.ortxtCpnoNm = value.name;
      }
    });

    //운송코드 셋팅
    let trnMnCd = gnrMrinFtrnOdVo.trnMnCd;
    state.trnMnNmCd = trnMnCd;

    _.each(state.trnMnNmList, function (value, idx) {
      if (state.trnMnNmCd == value.code) {
        state.trnMnNmCdNm = value.name;
      }
    });

    //운송수단명 셋팅
    let ftrnOdNm = gnrMrinFtrnOdVo.ftrnOdNm;
    state.trnMnNm = ftrnOdNm;

    //개시일 셋팅
    state.currentDate = result.body.sbcpDt;

    //품목코드 셋팅
    let itmCd = cargSbcDsgObjInfBcVo.itmCd;
    state.itmCd = itmCd;

    //H-S CODE 셋팅
    let hsCd = cargSbcDsgObjInfBcVo.hsCd;
    state.hsCd = hsCd;

    //포장 형태 셋팅
    let packCd = cargSbcDsgObjInfBcVo.packCd;
    state.packShCd = packCd;
    _.each(state.packShList, function (value, idx) {
      if (packCd == value.code) {
        state.packShNm = value.name;
      }
    });

    //희망 이익률
    let hopPftRt = result.body.hopPftRt;
    state.hop = hopPftRt;

    //입력 금액
    let ttInvcVamtAmt = result.body.ttInvcVamtAmt;
    state.ttInvcVamtAmt = ttInvcVamtAmt;

    //갑판적율
    // let odshRt = result.body.odshRt;
    // state.odshRt = odshRt;

    //보험가입금액 환종코드 셋팅
    let insVamtCurCd = result.body.insVamtCurCd;
    state.cur = insVamtCurCd;

    _.each(state.curList, function (value, idx) {
      if (insVamtCurCd == value.code) {
        state.curNm = value.code + "/" + value.name;
      }
    });
  }
}
</script>

<style></style>
